import React from 'react';
import Modal from 'react-modal';
import Documents from '../SettingsComponent/DocumentsComponent/Documents';
import './TenantDocumentsUploadModal.css';

const TenantDocumentsUploadModal = ({ isOpen, onClose, onUploadSuccess }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Upload Documents"
      shouldCloseOnOverlayClick
      ariaHideApp={false}
      className="tenant-documents-upload-modal"
      overlayClassName="tenant-documents-upload-modal-overlay"
    >
      <div className="tenant-documents-upload-modal-inner">
        <button
          type="button"
          className="tenant-documents-upload-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <Documents
          requireMinimumDocuments
          onUploadSuccess={onUploadSuccess}
          embeddedInModal
        />
      </div>
    </Modal>
  );
};

export default TenantDocumentsUploadModal;
